import { render } from "./SvgImage.vue?vue&type=template&id=5470186b&scoped=true"
import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"

import "./SvgImage.vue?vue&type=style&index=0&id=5470186b&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-5470186b"

export default script